class SectionParallax {
    constructor(container, elementsConfig) {
        this.container = container;
        this.elements = [];
        this.pointerTarget = { x: 0, y: 0 };
        this.pointerCurrent = { x: 0, y: 0 };
        this.scrollTarget = 0;
        this.scrollCurrent = 0;
        this.rafId = null;
        this.mobileMediaQuery = window.matchMedia('(max-width: 767px)');
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (this.prefersReducedMotion) {
            return;
        }

        elementsConfig.forEach((config) => {
            const nodes = this.container.querySelectorAll(config.selector);

            nodes.forEach((element) => {
                const baseTransform = window.getComputedStyle(element).transform;

                this.elements.push({
                    element,
                    baseTransform: baseTransform === 'none' ? '' : baseTransform,
                    pointerX: config.pointerX ?? 0,
                    pointerY: config.pointerY ?? 0,
                    scrollY: config.scrollY ?? 0,
                });

                element.style.willChange = 'transform';
            });
        });

        if (!this.elements.length) {
            return;
        }

        this.handlePointerMove = this.handlePointerMove.bind(this);
        this.handlePointerLeave = this.handlePointerLeave.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.animate = this.animate.bind(this);

        this.container.addEventListener('mousemove', this.handlePointerMove);
        this.container.addEventListener('mouseleave', this.handlePointerLeave);
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleScroll);

        this.handleScroll();
        this.animate();
    }

    handlePointerMove(event) {
        const rect = this.container.getBoundingClientRect();
        const relativeX = ((event.clientX - rect.left) / rect.width) * 2 - 1;
        const relativeY = ((event.clientY - rect.top) / rect.height) * 2 - 1;

        this.pointerTarget.x = Number.isFinite(relativeX) ? relativeX : 0;
        this.pointerTarget.y = Number.isFinite(relativeY) ? relativeY : 0;
    }

    handlePointerLeave() {
        this.pointerTarget.x = 0;
        this.pointerTarget.y = 0;
    }

    handleScroll() {
        const rect = this.container.getBoundingClientRect();
        const viewportCenter = window.innerHeight / 2;
        const sectionCenter = rect.top + rect.height / 2;
        const distanceFromCenter = (viewportCenter - sectionCenter) / viewportCenter;

        this.scrollTarget = Math.max(Math.min(distanceFromCenter, 1), -1);
    }

    animate() {
        this.pointerCurrent.x += (this.pointerTarget.x - this.pointerCurrent.x) * 0.08;
        this.pointerCurrent.y += (this.pointerTarget.y - this.pointerCurrent.y) * 0.08;
        this.scrollCurrent += (this.scrollTarget - this.scrollCurrent) * 0.06;
        const scrollMultiplier = this.mobileMediaQuery.matches ? 0.5 : 1;

        this.elements.forEach((item) => {
            const moveX = this.pointerCurrent.x * item.pointerX;
            const moveY = this.pointerCurrent.y * item.pointerY + this.scrollCurrent * item.scrollY * scrollMultiplier;

            item.element.style.transform = `${item.baseTransform} translate3d(${moveX}px, ${moveY}px, 0)`;
        });

        this.rafId = window.requestAnimationFrame(this.animate);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const parallaxSections = document.querySelectorAll('.homepage-diagnostic, .offer-section--image25_text50_image_25, .free-care-content');
    const isMobile = window.matchMedia('(max-width: 768px)').matches;

    if (!parallaxSections.length) {
        return;
    }

    parallaxSections.forEach((section) => {
        // Homepage diagnostic side images are hidden on mobile — skip parallax there.
        if (isMobile && section.classList.contains('homepage-diagnostic')) {
            return;
        }

        new SectionParallax(section, [
            {
                selector: '.diagnostic__image--left',
                pointerX: -27,
                pointerY: -18,
                scrollY: -67.5,
            },
            {
                selector: '.diagnostic__image--right',
                pointerX: 36,
                pointerY: 27,
                scrollY: 90,
            },
            {
                selector: '.free-care-content__image--left',
                pointerX: -27,
                pointerY: -18,
                scrollY: 140,
            },
            {
                selector: '.free-care-content__image--right',
                pointerX: 56,
                pointerY: 27,
                scrollY: -240,
            },
        ]);
    });
});